module.exports = __webpack_public_path__ + "614c30e1-5cec-4823-89c9-4d71f9b6a788/img/watermark-logo.72d4b776.png";